import React from 'react';
import AppLayout from '../components-app/AppLayout';
import OverviewList from '../components-static/OverviewList';
import {PageMenu,DeleteListItem,GenerateSpreadsheet,AddListItem,MobileMenu} from '../components-static/Common';
import {EditSizeLabel,EditableBox,EditableSelect,Box,Select,TextButton,Button,BoolSlider,Checkbox} from '../components-static/Input';
import u from '../utilities/Utilities';
import {PermissionTypes,PermissionTypeOptions} from "../data/Permissions";
import PropTypes from 'prop-types';
import {Spreadsheet} from '../data/Mimetypes';
import '../styles/permission-group-list.scss';
import '../styles/staff.scss';
import moment from 'moment';

const ModdedPermissionTypes = (u.getSuperUser()) ? PermissionTypes : PermissionTypes.slice(2);

export default class PermissionGroupList extends React.Component{

    state={
        selected:{
            tags:[],
            all:false,
            data:[],
            entryCount:0
        },
        pageMenuButtons:[],
        spreadsheetOptions:[],
        addError:"",
        permissions:{},
        selectMode:false,
        cargoLiftOptions:[],
        isSuperUser:u.getSuperUser(),
    };

    pageData={
        title:"Permission Groups",
        permission:"permissions",
        url:"/permissions-list",
        scrollAnchor:u.getKey(),
    };

    listData={
        deleteURL:"/api/delete-permission-group-entries",
        spreadsheetURL:"/api/generate-permission-group-spreadsheet",
        overviewURL:"/api/get-all-permission-groups",
        overviewLabel:"permission-list",
        orderByField:"groupName",
        orderByType:"ascending",
        numRows:20,
        checkboxPermissions:{},
        listOptions:[
            {label:"Tag Setting",ref:"macro",enabled:true,type:"list"},
        ]
    };

    componentDidMount=()=>{
        this.getCargoLiftOptions();
        const permissions = u.getPermissions("permissions");
        this.setState({
            permissions:permissions,
            pageMenuButtons:[
                {label:"Add", mobileLabel:"Add Group",ref:"add",image:"/images/page-menu/add.png",title:"Add new group",enabled:(permissions.create==2)},
                /*{label:"Template", mobileLabel:"Download Template",ref:"download",image:"/images/page-menu/template.png",title:"Download bulk add template",enabled:(permissions.create==2),onClick:this.onDownloadTemplate},*/
                {label:"Delete", mobileLabel:"Delete Group",ref:"delete",image:"/images/page-menu/delete.png",title:"Delete selected group",enabled:(permissions.delete==2)},
                {label:"Spreadsheet", mobileLabel:"Generate Spreadsheet",ref:"spreadsheet",image:"/images/page-menu/spreadsheet.png",title:"Generate spreadsheet from selection",enabled:true},
            ]
        });
    };

    getCargoLiftOptions=()=>{
        u.post({
            url:"/api/get-cargo-lift-options",
            data:{
                tenantID:u.getTenantID()
            },
            success:(cargoLiftOptions)=>{
                this.setState({cargoLiftOptions:cargoLiftOptions});
            },
            error:(error)=>{
                this.setState({error:error});
            }
        });
    }

    onMenuOptionClicked=(ref,show,mobileNav)=>{
        if(mobileNav){
            const toggle = (this.mobileSelect != ref);
            this.setState({selectMode:((ref=="spreadsheet" || ref=="delete") && toggle)});
            this.mobileSelect= ((toggle) ? ref : null);
            for(var i=0; i<mobileNav.length; i++){
                const r = mobileNav[i].ref;
                const show = (r == ref);

                if(show){
                    if(mobileNav[i].onClick){
                        mobileNav[i].onClick();
                    }
                    else if(mobileNav[i].type == "list"){
                        this.refs['overview'].triggerListOptions(r,toggle);
                    }
                    else{
                        this.refs[r].show(toggle);
                    }
                }
                else{
                    if(mobileNav[i].onClick) {

                    }
                    else if(mobileNav[i].type == "list"){
                        this.refs['overview'].triggerListOptions(r,false);
                    }
                    else{
                        this.refs[r].show(false);
                    }
                }
            }
        }
        else{
            this.setState({selectMode:((ref=="spreadsheet" || ref=="delete") && show)});
            this.refs[ref].show(show);
        }
    };

    onToggleForm=(ref,show)=>{
        this.refs['menu'].toggleForm(ref,show);
        this.mobileSelect=(show) ? ref : null;
    };

    onSelectChange=(selected)=>{
        this.setState({selected:selected});
    };

    onRefreshList=()=>{
        this.refs['overview'].onRefreshList();
    };

    onContentGrabbed=(content)=>{
        this.setState({spreadsheetOptions:content.spreadsheetOptions});
    };

    onDownloadTemplate=()=>{
        u.post({
            url:"/api/get-add-permission-group-template",
            data:{},
            success:(callback)=>{
                u.download(callback.filename,callback.filestamp, ()=>{},
                (error,status)=>{
                    this.setState({error:error});
                });
            },
            error:(error,status)=>{
                this.setState({error:error});
            }
        })
    };

    render=()=>{
        const mobileMenu = this.state.pageMenuButtons.concat(this.listData.listOptions);
        return (
            <AppLayout title={this.pageData.title} requiredPermission={this.pageData.permission} url={this.pageData.url}>
                <div className="page-error">{this.state.error}</div>
                <PageMenu id={this.pageData.scrollAnchor} title={this.pageData.title} ref="menu" buttons={this.state.pageMenuButtons} onMenuOptionClicked={this.onMenuOptionClicked}>
                    <AddEntry scrollAnchor={this.pageData.scrollAnchor} ref="add" reference="add" onToggleForm={this.onToggleForm} onRefreshList={this.onRefreshList} cargoLiftOptions={this.state.cargoLiftOptions} isSuperUser={this.state.isSuperUser}/>
                    <DeleteListItem scrollAnchor={this.pageData.scrollAnchor} ref="delete" reference="delete" url={this.listData.deleteURL} selected={this.state.selected} onToggleForm={this.onToggleForm} onRefreshList={this.onRefreshList}/>
                    <GenerateSpreadsheet scrollAnchor={this.pageData.scrollAnchor} ref="spreadsheet" url={this.listData.spreadsheetURL} options={this.state.spreadsheetOptions} reference="spreadsheet" selected={this.state.selected} onToggleForm={this.onToggleForm}/>
                </PageMenu>
                <OverviewList ref="overview" selectMode={this.state.selectMode} url={this.listData.overviewURL} label={this.listData.overviewLabel} numRows={this.listData.numRows} orderByField={this.listData.orderByField} orderByType={this.listData.orderByType} onSelectChange={this.onSelectChange} registerReference={this.registerReference} onContentGrabbed={this.onContentGrabbed} onMutatedChange={this.onMutatedChange} checkboxPermissions={this.listData.checkboxPermissions}>
                    {
                        (content,index,onChange,onContentChange,registerRef)=>{
                            return (
                                <PermissionGroupItem key={index} index={index} content={content} onChange={onChange} onContentChange={onContentChange} registerReference={registerRef} permissions={this.state.permissions} cargoLiftOptions={this.state.cargoLiftOptions} isSuperUser={this.state.isSuperUser}/>
                            )
                        }
                    }
                </OverviewList>
                <MobileMenu content={mobileMenu} onClick={this.onMenuOptionClicked}/>
            </AppLayout>
        )
    }
}

class PermissionGroupItem extends React.Component{

    permURL="/api/edit-group-permissions";

    state={
        error:"",
        cargoLiftOptions:[],
        updateOptions:true,
    };

    static getDerivedStateFromProps(props,state){
        if(state.updateOptions){
            let cargoLiftOptions = JSON.parse(JSON.stringify(props.cargoLiftOptions));
            state.cargoLiftOptions = cargoLiftOptions.map(
                (item)=>{
                    let options = item.options;
                    for(var i=0; i<props.content.cargoLiftFloors.length; i++){
                        const f = props.content.cargoLiftFloors[i];
                        if(item.block == f.block){
                            options = item.options.map(
                                (option)=>{
                                    let selected = false;
                                    for(var j=0; j<f.floors.length; j++){
                                        if(f.floors[j] == option.value){
                                            selected=true;
                                            break;
                                        }
                                    }
                                    option.selected = selected;
                                    return option;
                                }
                            )
                        }
                    }
                    item.options=options;
                    return item;
            });
            state.updateOptions=false;
        }
        return state;
    }

    componentDidUpdate=(prevProps,prevState)=>{
        if(prevProps.content != this.props.content){
            this.setState({updateOptions:true});
        }
    }

    onChangePermission=(value,key,module,onError,option)=>{
        this.setState({error:""});
        let allPermissions = this.props.content.permissions;
        if(typeof allPermissions == "undefined"){
            allPermissions = {};
        }
        if(typeof allPermissions[module] == "undefined"){
            allPermissions[module] = {};
        }
        allPermissions[module][key] = parseInt(value);

        if(value == 2){
            allPermissions[module].general = 2;
        }

        this.props.onChange(allPermissions,"permissions",this.props.index);
    };

    onChangeSlider=(value,index)=>{
        this.setState({error:""});
        const oldValue = (!value) ? 2 : 0;
        const newValue = (value) ? 2 : 0;
        u.post({
            url:this.permURL,
            data:{
               oldValue:oldValue,
               newValue:newValue,
               id:{tenantID:this.props.content.tenantID,groupID:this.props.content.groupID},
               field:index.itemKey,
               additionalData:index.moduleKey
            },
            success:()=>{
                this.onChangePermission(newValue,index.itemKey,index.moduleKey);
            },
            error:(error)=>{
                this.setState({error:error});
            }
        });
    };

    onSelectAll=(index)=>{
        let cargoLiftOptions = this.state.cargoLiftOptions;
        let cargoLiftFloors = this.props.content.cargoLiftFloors;
        const selected = !cargoLiftOptions[index].selected;
        let blockIndex = cargoLiftFloors.findIndex((item)=>{
            return item.block == cargoLiftOptions[index].block;
        });

        if(selected){

            if(blockIndex == -1){
                blockIndex = cargoLiftFloors.length;
                cargoLiftFloors.push({block:cargoLiftOptions[index].block,floors:[]});
            }

            //Push all
            cargoLiftFloors[blockIndex].floors = cargoLiftOptions[index].options.map(
                (item)=>{
                    return item.value;
                }
            )

            cargoLiftOptions[index].options = cargoLiftOptions[index].options.map((item)=>{
                item.selected=true;
                return item;
            })
        }
        else{
            cargoLiftFloors[blockIndex].floors = [];
            cargoLiftOptions[index].options = cargoLiftOptions[index].options.map((item)=>{
                item.selected=false;
                return item;
            });
        }

        cargoLiftOptions[index].selected = selected;
        this.setState({cargoLiftOptions:cargoLiftOptions});
        this.props.onChange(cargoLiftFloors,"cargoLiftFloors",this.props.index);
        this.updateServerCargoLift(cargoLiftFloors);
    }

    onChangeCargo=(value,index,oindex)=>{
        let cargoLiftFloors = this.props.content.cargoLiftFloors;
        let cargoLiftOptions = this.state.cargoLiftOptions;

        cargoLiftOptions[index].options[oindex].selected=value;

        let blockIndex = cargoLiftFloors.findIndex((item)=>{
            return item.block == cargoLiftOptions[index].block;
        });

        if(value){
            if(blockIndex == -1){
                blockIndex = cargoLiftFloors.length;
                cargoLiftFloors.push({block:cargoLiftOptions[index].block,floors:[]});
            }
            cargoLiftFloors[blockIndex].floors.push(cargoLiftOptions[index].options[oindex].value);
        }
        else{
            for(var i=0; i<cargoLiftFloors[blockIndex].floors.length; i++){
                if(cargoLiftFloors[blockIndex].floors[i] == cargoLiftOptions[index].options[oindex].value){
                    cargoLiftFloors[blockIndex].floors.splice(i,1);
                    break;
                }
            }
        }

        this.setState({cargoLiftOptions:cargoLiftOptions});
        this.updateServerCargoLift(cargoLiftFloors);
        this.props.onChange(cargoLiftFloors,"cargoLiftFloors",this.props.index);
    }

    updateServerCargoLift=(cargoLiftFloors)=>{
        u.post({
            url:"/api/update-permission-group-info",
            data:{
                newValue:cargoLiftFloors,
                field:"cargoLiftFloors",
                id:{groupID:this.props.content.groupID,tenantID:this.props.content.tenantID},
            },
            success:()=>{},
            error:(error)=>{
                this.setState({error:error});
            }
        });
    }

    render=()=>{
        const content = this.props.content;
        const edit = (this.props.permissions.update == 2);
        const url = "/api/update-permission-group-info";
        const index = this.props.index+""
        const id = {groupID:content.groupID,tenantID:content.tenantID};

        return (
            <div style={{textAlign:"center"}}>

                <div className="list-segment extended" style={{textAlign:"left"}}>
                    <div className="list-segment-item">
                        <div className="list-segment-label">Group Name:</div>
                        <div className="list-segment-input">
                            <EditableBox label="Group Name" field="groupName" values={{value:content.groupName,enabled:edit}} rules={{required:true,nullText:"None"}} index={index} id={id} url={url} onChange={this.props.onChange}/>
                        </div>
                    </div>
                    <div className="list-segment-item">
                        <div className="list-segment-label">Tenant:</div>
                        <div className="list-segment-input"><EditSizeLabel>{content.tenantName}</EditSizeLabel></div>
                    </div>
                </div>

                <div className="list-segment extended" style={{textAlign:"left"}}>
                    <div className="list-segment-item">
                        <div className="list-segment-label">Users Assigned:</div>
                        <div className="list-segment-input"><EditSizeLabel nullText="None">{content.numUsers}</EditSizeLabel></div>
                    </div>
                    <div className="list-segment-item">
                        <div className="list-segment-label">Created By:</div>
                        <div className="list-segment-input"><EditSizeLabel nullText="None">{content.createdByName}</EditSizeLabel></div>
                    </div>
                </div>

                <div className="permissions-divider"/>
                <div>{this.state.error}</div>
                <div className="permissions-div">
                    <Permissions content={content} permissions={edit} url="edit-group-permissions" onChange={this.onChangePermission} type="slider" onChangeSlider={this.onChangeSlider}/>
                </div>

                {
                    (this.props.isSuperUser)
                        ?
                        <div>
                            <div className="permissions-divider"/>
                            <h3>Cargo Lift Access</h3>
                            {
                                this.state.cargoLiftOptions.map(
                                    (item,index)=>{
                                        return (
                                            <div key={index} style={{textAlign:"center",margin:"15px auto"}}>
                                                <div className="bold" style={{margin:"10px auto"}}>
                                                    <TextButton onClick={()=>{this.onSelectAll(index)}}>{item.block}</TextButton>
                                                </div>
                                                {
                                                    item.options.map(
                                                        (option,oindex)=>{
                                                            return <div key={oindex} style={{display:"inline-block",margin:"5px 7px"}}>
                                                                        <div><Checkbox values={{value:option.selected}} label="Cargo Lift Option" index={oindex+""} onChange={(value)=>{this.onChangeCargo(value,index,oindex)}}/></div>
                                                                        <div>{option.label}</div>
                                                                    </div>
                                                                }
                                                    )
                                                }
                                            </div>
                                        )
                                    }
                                )
                            }
                        </div>
                        :
                        ""
                }
            </div>
        )
    }
}

class AddEntry extends React.Component{

    state={
        error:"",
        entryData:{
            permissions:{}
        },
        cargoLiftOptions:JSON.parse(JSON.stringify(this.props.cargoLiftOptions))
    };

    static getDerivedStateFromProps(props,state){
        if(props.cargoLiftOptions.length != state.cargoLiftOptions.length){
            state.cargoLiftOptions = JSON.parse(JSON.stringify(props.cargoLiftOptions));
        }
        return state;
    }

    addData={
        addType:0,
        addURL:"/api/add-permission-group",
        bulkAddURL:"/api/add-bulk-permission-group"
    };

    show=(show)=>{
        this.refs[this.props.reference].show(show);
    }

    onChangeEntry=(value,label,index,option)=>{
        let entryData=this.state.entryData;
        entryData[label]=value;
        this.setState({entryData:entryData});
    }

    onAddEntry=()=>{
        this.setState({error:""});
        const inputs = ['groupName'];
        for(var i=0; i<inputs.length; i++){
            const current = this.refs[inputs[i]].validate();
            if(!current.valid){
                this.setState({error:current.value});
                return 0;
            }
        }

        let permissionCheck = false;
        const permissions = this.state.entryData.permissions;
        for(var module in permissions){
            for(var item in permissions[module]){
                if(permissions[module][item] == 2){
                    permissionCheck = true;
                    break;
                }
            }
        }
        /*if(!permissionCheck){
            this.setState({error:"Please select at least 1 permission for this group"});
            return 0;
        }*/

        let cargoLiftFloors = this.state.cargoLiftOptions.map(
            (block)=>{
                const floors = block.options
                .filter(
                    (option)=>{return option.selected})
                    .map(
                        (option)=>{return option.value});

                return {block:block.block,floors:floors};
            }
        )

        let entryData = this.state.entryData;
        entryData.cargoLiftFloors=cargoLiftFloors;

        this.refs[this.props.reference].onValidated(entryData);
    };

    onComplete=()=>{
        this.setState({
            error:"",
            entryData:{permissions:{}},
            cargoLiftOptions:this.state.cargoLiftOptions.map(
                (block)=>{
                    const options = block.options.map(
                        (option)=>{
                            option.selected=false;
                            return option;
                        }
                    )
                    return {block:block.block,options:options}
                }
            )
        });
    };

    onChangeSlider=(value,index)=>{
        let permissions = this.state.entryData.permissions;
        if(typeof permissions[index.moduleKey]=="undefined"){
            permissions[index.moduleKey]={};
        }
        if(typeof permissions[index.moduleKey][index.itemKey] == "undefined"){
            permissions[index.moduleKey][index.itemKey] = {};
        }
        permissions[index.moduleKey][index.itemKey] = (value) ? 2 : 0;
        if(value){
            permissions[index.moduleKey].general = 2;
        }
        this.onChangeEntry(permissions,"permissions");
    }

    onChangeCargo=(value,index,oindex)=>{
        let cargoLiftOptions=this.state.cargoLiftOptions;
        cargoLiftOptions[index].options[oindex].selected=value;
        this.setState({cargoLiftOptions:cargoLiftOptions});
    }

    onSelectAll=(index)=>{
        let cargoLiftOptions=this.state.cargoLiftOptions;
        const selected = !cargoLiftOptions[index].selected;
        cargoLiftOptions[index].options = cargoLiftOptions[index].options.map(
            (item)=>{
                item.selected=selected;
                return item;
            }
        )
        cargoLiftOptions[index].selected=selected;
        this.setState({cargoLiftOptions:cargoLiftOptions});
    }

    render=()=>{
        const content=this.state.entryData;
        return (
            <AddListItem scrollAnchor={this.props.scrollAnchor} ref={this.props.reference}
                         reference={this.props.reference} addType={this.addData.addType}
                         index={this.addData.addIndex} label={this.addData.label} bulkURL={this.addData.bulkAddURL}
                         filetypes={Spreadsheet} url={this.addData.addURL} onToggleForm={this.props.onToggleForm}
                         onRefreshList={this.props.onRefreshList} onComplete={this.onComplete}>
                <div style={{textAlign:"center"}}>
                    <h3>Complete the following to continue</h3>
                    <div className="segment-error">{this.state.error}</div>
                    <div className="segment-content">
                        <div className="segment-margin-area">
                            <div className="segment-full-item">
                                <div className="segment-item-label">Group Name:</div>
                                <div className="segment-item-input">
                                    <Box ref="groupName" label="Group Name" field="groupName" values={{value:content.groupName}} rules={{required:true}} onChange={this.onChangeEntry}/>
                                </div>
                            </div>
                        </div>

                        <div className="segment-margin-area permissions-div-add">
                             <Permissions content={content} type="slider" permissions={true} url="None" onChangeSlider={this.onChangeSlider}/>
                        </div>

                        {
                            (this.props.isSuperUser)
                                ?
                                <div className="segment-margin-area">
                                    <h3>Cargo Lift Access</h3>
                                    <div>
                                        {
                                            this.state.cargoLiftOptions.map(
                                                (block,index)=>{
                                                    return (
                                                        <div key={index} style={{margin:"15px auto"}}>
                                                            <div className="bold">
                                                                <TextButton onClick={()=>{this.onSelectAll(index)}}>{block.block}</TextButton>
                                                            </div>
                                                            <div style={{margin:"10px auto"}}>
                                                                {
                                                                    block.options.map(
                                                                        (option,oindex)=>{
                                                                            return (
                                                                                <div key={oindex} style={{display:"inline-block",margin:"5px 7px"}}>
                                                                                    <div><Checkbox values={{value:option.selected}} onChange={(value)=>{this.onChangeCargo(value,index,oindex)}}/></div>
                                                                                    <div>{option.label}</div>
                                                                                </div>
                                                                            )
                                                                        }
                                                                    )
                                                                }
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            )
                                        }
                                    </div>
                                </div>
                                :
                                ""
                        }

                        <div className="segment-margin-area">
                            <div className="segment-error">{this.state.error}</div>
                            {
                                (u.isMobileDevice())
                                ?
                                <Button type="medium" onClick={()=>{this.props.onToggleForm(this.props.reference,false)}}>Cancel</Button>
                                :
                                ""
                            }
                            <Button type="medium" onClick={this.onAddEntry}>Add Entry</Button>
                        </div>
                    </div>
                </div>
            </AddListItem>
        )
    }
}
AddEntry.propTypes={
    scrollAnchor:PropTypes.string,
    onToggleForm:PropTypes.func.isRequired,
    onRefreshList:PropTypes.func.isRequired,
};

export class Permissions extends React.Component{

    render(){
        const content = this.props.content;
        const edit = (this.props.permissions && !this.props.noEdit);
        const editPermissionAPI = this.props.url;

        return(
            <div>
                {
                    ModdedPermissionTypes.map(
                        (module, aspIndex)=> {
                            const asp = (typeof content.permissions[module.moduleKey] == "undefined") ? {} : content.permissions[module.moduleKey];
                            return (
                                <div className="permission-type" key={aspIndex}>
                                    <div className="permission-type-module">{module.module}</div>
                                    <div className="permission-type-content">
                                        {
                                            module.permissions.map(
                                                (item, ispIndex)=> {
                                                    const isp = (typeof asp[item.key] == "undefined") ? "0" : asp[item.key] + "";
                                                    return (
                                                        <div className="permission-type-item" key={ispIndex}>
                                                            <div className="permission-type-label">
                                                                <span className="permission-type-label-content">{item.label}</span>
                                                                <div className="permission-type-popup">
                                                                    {
                                                                        item.elaboration.map(
                                                                            (elab, elabIndex)=> {
                                                                                return (
                                                                                    <div key={elabIndex}
                                                                                         className="permission-type-popup-item">
                                                                                        <div className="permission-type-popup-header">{elab.header}</div>
                                                                                        <div className="permission-type-popup-input">{elab.text}</div>
                                                                                    </div>
                                                                                )
                                                                            }
                                                                        )
                                                                    }
                                                                </div>
                                                            </div>
                                                            <div className="permission-type-input">
                                                                <BoolSlider index={{moduleKey:module.moduleKey,itemKey:item.key}} value={(isp==2)} onChange={this.props.onChangeSlider} enabled={edit} onNoPermission={this.props.onError}/>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            )
                                        }
                                    </div>
                                </div>
                            )
                        }
                    )
                }
            </div>
        )
    }
}
Permissions.propTypes={
    noEdit:PropTypes.bool,
    content:PropTypes.object.isRequired,
    permission:PropTypes.bool,
    url:PropTypes.string,
    type:PropTypes.string,
};
